import { Component } from '@angular/core';
import { APPCONFIG } from '../../config';

@Component({
  selector: 'my-app-search-overlay',
  styles: [],
  templateUrl: './search-overlay.component.html'
})

export class AppSearchOverlayComponent {

}
